import Leaflet from "leaflet";

import iconUrlBusAtStop from "../assets/icons/busAtStop.svg";
import iconUrlBlack from "../assets/icons/busBlack.svg";
import iconUrlBlue from "../assets/icons/busBlue.svg";
import iconUrlSelectedPosition from "../assets/icons/positionSelectedIcon.svg";
import iconUrlBusStationMap from "../assets/icons/busStationMap.svg";
import iconUrlTechnicalVehicle from "../assets/icons/technicalVehicle.svg";
import iconUrlPersonalCar from "../assets/icons/personalCar.svg";

//* Remaining bus - MapComponent.tsx
export const busIconBlack = new Leaflet.Icon({
  iconUrl: iconUrlBlack,
  iconAnchor: [14, 14],
  popupAnchor: [0, -14],
  tooltipAnchor: [0, 0],
  iconSize: [28, 28],
  className: "bus_icon",
});

//* At stop (indigoColor) - Last24HoursReportMap.tsx
export const busAtStop = new Leaflet.Icon({
  iconUrl: iconUrlBusAtStop,
  iconAnchor: [14, 14],
  popupAnchor: [0, -14],
  tooltipAnchor: [0, 0],
  iconSize: [28, 28],
  className: "bus_icon",
});

//* Active bus - MapComponent.tsx + Last24HoursReportMap.tsx
export const busIconBlue = new Leaflet.Icon({
  iconUrl: iconUrlBlue,
  iconAnchor: [19, 19],
  popupAnchor: [0, -19],
  tooltipAnchor: [0, 0],
  iconSize: [38, 38],
  className: "bus_icon",
});

export const positionSelectedIcon = new Leaflet.Icon({
  iconUrl: iconUrlSelectedPosition,
  iconAnchor: [16, 32],
  tooltipAnchor: [0, -32],
  iconSize: [32, 32],
  className: "bus_icon",
});

export const busStationMapIcon = new Leaflet.Icon({
  iconUrl: iconUrlBusStationMap,
  iconAnchor: [22, 44],
  tooltipAnchor: [0, -44],
  iconSize: [44, 44],
  className: "bus_icon",
});

export const technicalVehicleIcon = new Leaflet.Icon({
  iconUrl: iconUrlTechnicalVehicle,
  iconAnchor: [14, 14],
  popupAnchor: [0, -14],
  tooltipAnchor: [9, 0],
  iconSize: [28, 28],
  className: "bus_icon technical",
});

export const personalCarIcon = new Leaflet.Icon({
  iconUrl: iconUrlPersonalCar,
  iconAnchor: [14, 14],
  popupAnchor: [0, -14],
  tooltipAnchor: [-9, 0],
  iconSize: [28, 28],
  className: "bus_icon technical",
});
